var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.length > 0)?_c('div',{ref:"Circular",staticClass:"mid"}):_c('div',{staticClass:"mid",staticStyle:{"text-align":"center"}},[_vm._v("暂无数据")])
}
var staticRenderFns = []

export { render, staticRenderFns }